import React from 'react'
import PropTypes from 'prop-types'
import styled from 'react-emotion'
import { mediumMediaQuery } from 'utils/style-helpers'
import checkIcon from './check.svg'

const List = styled.ul`
  display: inline-block;
  margin: 0;
  text-align: left;
`

const ListItem = styled.li`
  font-size: 20px;
  list-style: none;
  margin: 0 0 25px 34px;
  text-transform: uppercase;

  &:before {
    background: url(${checkIcon}) no-repeat;
    content: "";
    display: inline-block;
    height: 24px;
    margin: 0 10px 0 -34px;
    width: 24px;
  }

  p {
    display: inline-block;
  }

  &:before, p {
    line-height: 24px;
    vertical-align: top;
  }
`

const Checklist = ({ checklist }) => (
  <List>
    {checklist.map((item, index) =>
      <ListItem key={index}><p>{item}</p></ListItem>
    )}
  </List>
)

Checklist.propTypes = {
  checklist: PropTypes.array.isRequired
}

export default Checklist



// WEBPACK FOOTER //
// ./src/components/Benefits/Benefit/Checklist/index.js